import React from 'react';
import { Link } from 'react-router-dom';

const Contact: React.FC = () => {
  return (
    <div className="container my-5">
      <div className="row mb-5">
        <div className="col-lg-8 mx-auto text-center">
          <h1 className="display-4 fw-bold">Contact Us</h1>
          <p className="lead">
            Have questions about our services? Get in touch with us today.
          </p>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-5">
              <div className="row">
                <div className="col-md-6 mb-4 mb-md-0">
                  <div className="mb-4">
                    <h4 className="d-flex align-items-center mb-3">
                      <i className="bi bi-telephone-fill me-2" style={{ color: '#0D4D26' }}></i>
                      Phone
                    </h4>
                    <p className="ms-4 mb-0">
                      <a href="tel:+15195752836" className="text-decoration-none h5">+1 519-575-2836</a>
                    </p>
                  </div>
                  
                  <div className="mb-4">
                    <h4 className="d-flex align-items-center mb-3">
                      <i className="bi bi-envelope-fill me-2" style={{ color: '#0D4D26' }}></i>
                      Email
                    </h4>
                    <div className="ms-4">
                      <p className="mb-2">
                        <a href="mailto:Abhishek.Deswal@sterlingtax.ca" className="text-decoration-none">
                          Abhishek.Deswal@sterlingtax.ca
                        </a>
                      </p>
                      <p className="mb-0">
                        <a href="mailto:info@sterlingtax.ca" className="text-decoration-none">
                          info@sterlingtax.ca
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-4">
                    <h4 className="d-flex align-items-center mb-3">
                      <i className="bi bi-clock-fill me-2" style={{ color: '#0D4D26' }}></i>
                      Business Hours
                    </h4>
                    <div className="ms-4">
                      <p className="mb-2">Monday - Friday: 5:00 PM - 10:00 PM</p>
                      <p className="mb-2">Saturday & Sunday: By appointment only</p>
                    </div>
                  </div>
                  
                  <div>
                    <h4 className="d-flex align-items-center mb-3">
                      <i className="bi bi-geo-alt-fill me-2" style={{ color: '#0D4D26' }}></i>
                      Location
                    </h4>
                    <div className="ms-4">
                      <p className="mb-3">
                        Serving clients throughout the Greater Toronto Area, Ontario
                      </p>
                    </div>
                  </div>

                  <div>
                    <h4 className="d-flex align-items-center mb-3">
                      <i className="bi bi-calendar-check me-2" style={{ color: '#0D4D26' }}></i>
                      Schedule a Meeting
                    </h4>
                    <div className="ms-4">
                      <p className="mb-3">
                        Ready to discuss your tax needs? Schedule a consultation with our experts.
                      </p>
                      <Link to="/appointments" className="btn btn-primary">
                        Book an Appointment
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 